import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Drawer, TextField, Typography, Chip } from '@material-ui/core';
import { MultiSelect } from '../../components';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { GetDashboard, DashboardBranchChipChange } from 'store/actions';
import moment from 'moment';

const Filter = props => {
  const { openFilter, onClose, openCalendar } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const startDate = useSelector(({ dashboard }) => dashboard.startDate);
  const branchs = useSelector(({ branch }) => branch.branchs);
  const branchChips = useSelector(({ dashboard }) => dashboard.branchChips);

  const handleChipDelete = chipId => {
    let newValue = [...branchChips];
    if (newValue.length !== 1) {
      newValue = newValue.filter(item => item.id !== chipId);
      dispatch(DashboardBranchChipChange(newValue));
    }
  };

  const handleMultiSelectChange = value => {
    if (value.length !== 0) {
      dispatch(DashboardBranchChipChange(value));
    }
  };

  const handleSubmit = () => {
    dispatch(GetDashboard());
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={openFilter}
      variant="temporary"
    >
      <div className={classes.root}>
        <div className={classes.header}>
          <Button
            onClick={onClose}
            size="small"
          >
            <CloseIcon className={classes.buttonIcon} />
                        Close
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.contentSection}>
            <div className={classes.contentSectionHeader}>
              <Typography variant="h5">Dashboard filter</Typography>
            </div>

            <div className={classes.contentSectionContent}>
              <div className={classes.chips}>
                {branchChips.map(branchChip => (
                  <Chip
                    className={classes.chip}
                    color="primary"
                    deleteIcon={<CloseIcon />}
                    key={branchChip.id}
                    label={branchChip.branchName}
                    onDelete={() => handleChipDelete(branchChip.id)}
                    variant="outlined"
                  />
                ))}
              </div>

              <div className={classes.selects}>
                {branchs && (
                  <MultiSelect
                    key="Branch"
                    label="Select branch"
                    onChange={handleMultiSelectChange}
                    options={branchs}
                    value={branchChips}
                  />
                )}
              </div>

              {/* Date */}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="Year"
                  margin="dense"
                  name="Year"
                  onClick={() => openCalendar()}
                  value={moment(startDate).format('YYYY')}
                  variant="outlined"
                />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.actions}>
          <Button
            color="primary"
            fullWidth
            onClick={() => handleSubmit()}
            type="submit"
            variant="contained"
          >
                        Apply filters
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

Filter.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  openFilter: PropTypes.bool.isRequired
};

export default Filter;

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(0, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  chips: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'left',
    flexWrap: 'wrap'
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  selects: {
    paddingBottom: theme.spacing(2)
  }
}));
